var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellFour(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.334C20 15.2731 19.5786 14.2557 18.8284 13.5056C18.0783 12.7554 17.0609 12.334 16 12.334C14.9391 12.334 13.9217 12.7554 13.1716 13.5056C12.4214 14.2557 12 15.2731 12 16.334C12 21.0007 10 22.334 10 22.334H22C22 22.334 20 21.0007 20 16.334Z",
    stroke: "#2C303B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1533 25C17.0361 25.2021 16.8679 25.3698 16.6655 25.4864C16.4631 25.6029 16.2336 25.6643 16 25.6643C15.7664 25.6643 15.5369 25.6029 15.3345 25.4864C15.1321 25.3698 14.9639 25.2021 14.8467 25",
    stroke: "#2C303B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 1,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#FF9E7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1389 11V9.18H22.9189V8.69L26.1389 4H26.7689V8.59H28.2789V9.18H26.7689V11H26.1389ZM23.7089 8.59H26.1389V5.03L23.7089 8.59Z",
    fill: "#2C303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellFour);
export default __webpack_public_path__ + "static/media/bell-four.4f82125b6ad12c4553663028978c4ea4.svg";
export { ForwardRef as ReactComponent };